import { AxiosRequestConfig } from 'axios';
import { LanguageJSON } from '@/store/models/language';
import httpClient from '../http-client';
import { RequestConfig } from '../types';

export function list(config?: RequestConfig & Pick<AxiosRequestConfig, 'params'>) {
  return httpClient.get<LanguageJSON[]>('languages/list', config);
}
